"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _service = require("./service");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _mixpanelEventsFromDestination = require("@insided/deprecated-preact-components/utils/mixpanelEventsFromDestination");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-join-button';
exports.cssAnchorName = cssAnchorName;

var pageReload = function pageReload() {
  window.location.reload();
};

var GroupJoinButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupJoinButton, _Component);

  var _super = _createSuper(GroupJoinButton);

  function GroupJoinButton() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupJoinButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "joinGroup", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var userId, event;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userId = (0, _insidedDataStorage.getInsidedData)('user').userid;

              if (userId) {
                _context.next = 5;
                break;
              }

              event = new window.CustomEvent('GuestUserAction');
              window.dispatchEvent(event);
              return _context.abrupt("return");

            case 5:
              _this.setState({
                isLoading: true
              });

              _context.prev = 6;
              _context.next = 9;
              return (0, _service.joinGroup)({
                groupId: _this.props.groupId,
                csrfToken: _this.props.csrfToken
              });

            case 9:
              _this.setState({
                isLoading: false
              });

              _publish.default.trackEvent('userevent', {
                type: 'GroupMemberJoined',
                payload: 'method1',
                userId: userId,
                addedBy: userId
              });

              if (_this.props.isPrivateGroup) {
                (0, _mixpanelEventsFromDestination.trackRequestToJoinPrivateGroup)('RequestViaGroupDetailPage', _this.props.groupId);
              }

              pageReload();
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);

              _this.setState({
                isLoading: false
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 15]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(GroupJoinButton, [{
    key: "render",
    value: function render() {
      var isLoading = this.state.isLoading;
      var isPublicGroup = this.props.isPublicGroup;
      return (0, _preact.h)(_Button.default, {
        type: "button",
        className: "btn--cta btn",
        isLoading: isLoading,
        onClick: this.joinGroup,
        oldStyle: true,
        "data-bounded-context": "Groups",
        "data-entity": "group-join",
        "data-track-type": "click",
        "data-element-name": "Group Clicked Join"
      }, (0, _preact.h)(_phrase.default, {
        p: isPublicGroup ? 'groups.join.group' : 'groups.request.to.join'
      }));
    }
  }]);
  return GroupJoinButton;
}(_preact.Component);

var _default = GroupJoinButton;
exports.default = _default;